// Minimal HSA gating predicates. Keep this file free of any imports beyond
// `WidgetAutocheck` (which `index.ts` already pulls in) so these checks run
// without loading the heavy HSA bundle. The actual surfaces — the lightweight
// skip-Shop-Pay interception and the React questionnaire — are dynamically
// imported from `index.ts` only when these return true.
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";

export const isHsaEnabled = ({
  autocheck,
}: {
  autocheck: WidgetAutocheck;
}): boolean => !!autocheck.hsa.enabled;

export const isHsaSkipShopPayEnabled = ({
  autocheck,
}: {
  autocheck: WidgetAutocheck;
}): boolean =>
  autocheck.hsa.enabled && !!autocheck.hsa.checkoutButtonsSkipShopPay;
